<template>
<div class="login-box">
  <div class="login-logo">
    <span class="logo" v-html="logos"></span>
  </div>
  <!-- /.login-logo -->
  <div class="login-box-body">
    <div class="box-header with-border mb-10">
      <h4 class="box-title pull-left">Forgot Password</h4>
    </div>
    <b-form class="form-signup mt-10" v-on:submit.prevent="onSubmit" novalidate>
      <div class="form-label-group">
        <b-form-input @keyup="clearmsg()" type="text" class="form-control" id="user_email" placeholder="Enter Your Registered Email" v-model.lazy.trim="$v.form.user_email.$model" :state="chkState('user_email')" autofocus />
        <!-- <label v-if="form.user_email  != ''">Enter your e-mail</label> -->
        <div v-if="$v.form.user_email.$error">
          <p v-if="!$v.form.user_email.required" class="login-alert-msg error-content">* Enter your email</p>
          <p v-if="!$v.form.user_email.email" class="login-alert-msg error-content">* Enter the valid email</p>
        </div>
        <div v-if="errormsg == 'Email not exist!'">
          <p class="login-alert-msg error-content">* Email does not exists</p>
        </div>
      </div>
      <button class="btn btn-md btn-success btn-block btn__large_coman_hight" type="submit">Submit</button>
    </b-form>
  </div>
  <!-- /.login-box-body -->
</div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'
import { BaseURL } from '../../shared/classes'
import axios from 'axios'
import { logo } from '../../shared/svg_forget'
import router from '../../router/index'

const formShape = {
  user_email: ''
}
export default {
  name: 'forgetPassword',
  data () {
    return {
      form: Object.assign({}, formShape),
      hasError: false,
      userStatus: false,
      currentModel: '',
      paswordStrength: 0,
      logos: logo,
      errormsg: '',
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
    }
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      user_email: {
        required,
        email,
        minLength: minLength(5)
      }
    }
  },
  created () {
    localStorage.setItem('setPassword', JSON.stringify(false))
  },
  methods: {
    clearmsg () {
      this.errormsg = ''
    },
    onSubmit () {
      if (this.validate()) {
        this.$nextTick(() => {
          const data = {
            user_email: this.form.user_email.toLowerCase(),
            type_of_account: 'organization'
          }
          axios.post(BaseURL + '/email/update/user/using/email', {
            formData: data
          }, this.config).then(response => {
            if (response.data.message === 'Email not exist!') {
              this.errormsg = response.data.message
            }
            if (response.data.userdetail.user_email === data.user_email) {
              localStorage.setItem('setPassword', JSON.stringify(true))
              router.push({ name: 'forget-password-success' })
            } else {
              this.currentModel = this.form.user_email
              this.userStatus = true
            }
          }).catch(e => {
            console.log(e)
          })
        })
      } else {
        console.log('else................')
      }
    },
    userLogin () {
      router.push({ name: 'Login' })
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  }
}
</script>

<style scoped>
.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.form-holder {
  margin-left: 0px;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}
ul {
    padding: 0px;
}

.form-items {
  max-width: 540px
}
.form-content {
    width: auto;
}
.box {
  border-top: 0px solid #d2d6de;
  border-radius: 0px;
}
.form-content form {
    margin-bottom: 30px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
}
.box-header .box-title {
    display: inline-block;
    font-size: 16px;
    margin: 0;
    line-height: 1;
    color:black;
}
.form-items {
  margin-top: 8%;
}
</style>
